import axios from "@/plugins/axios";

export default {
  login(creds) {
    return axios.post("/login", creds);
  },

  loginWithOtp(creds) {
    return axios.post("/login/otp", creds);
  },

  verifyOtp(otp) {
    return axios.post("/otp/verify", otp);
  },

  resendOtp(reference) {
    return axios.post("/otp/resend", { reference });
  },

  forgotPassword(email) {
    return axios.post("/forgot_password", email);
  },

  logout() {
    return axios.post("/logout");
  },
};
